// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"RegulationsTable_disclaimer__RHoKP","description":"RegulationsTable_description__xgQZb"};